export default __webpack_public_path__ + "static/media/explore.f54ea224.gif";